import {createFeatureSelector, createSelector} from '@ngrx/store';
import {generateLoadStatusSelectorsFor, generateSelectorsDependentOn} from '@aviary/store/store.selector-generators';
import {MxSelector, NO_NAME_PREFIX} from '@aviary/store/store.types';
import {FALLBACK_ORGANIZATION} from './organization.fallback';
import {OrganizationState} from './organization.state';
import {GlobalNavLink, Organization, ORGANIZATION_FEATURE_KEY} from './organization.types';
import {isPopulatedString} from '@aviary/store/common/typing.helpers';

export const entireState: MxSelector<OrganizationState> = createFeatureSelector(ORGANIZATION_FEATURE_KEY);

export namespace OrganizationSelectors {
  export namespace Auth {
    const subState: MxSelector<OrganizationState['auth']> = createSelector(
      entireState,
      state => state.auth
    );

    export const {
      loading,
      loaded
    } = generateLoadStatusSelectorsFor(subState);

    export const organization: MxSelector<Organization> = createSelector(
      subState,
      _subState => _subState.data ?? FALLBACK_ORGANIZATION
    );

    export const {
      copyOverrides,
      name,
      bannerUrl,
      websiteUrl,
      phoneNumber,
      contactEmail,
      coverImageSource,
      usesMEL,
      novelistProfile: noveListProfile,
      novelistPassword: noveListPassword
    } = generateSelectorsDependentOn(organization, FALLBACK_ORGANIZATION, NO_NAME_PREFIX);

    export const hasBanner: MxSelector<boolean> = createSelector(
      bannerUrl,
      isPopulatedString
    );

    export const globalNavLinks: MxSelector<GlobalNavLink[]> = createSelector(
      organization,
      value => value.navigationLinks ?? []
    );

  } // namespace Auth
}
